import { faEdit, faPen } from '@fortawesome/pro-regular-svg-icons';
import React, { useState } from 'react';
import { GetSelectedKeywordsStatsGq } from '../../../../../graphql/projects/queries/useGetSelectedKeywordsStatsGq';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';
import EditKeywordsDialog from './EditKeywordsDialog';
import { KeywordTableState } from '../logic/useKeywordTableState';

export interface EditKeywordsButtonProps {
  selectedKeywordStats?: GetSelectedKeywordsStatsGq;
  tableState: KeywordTableState;
  selectedCount?: number;
  selectionActive?: boolean;
}

export const EditKeywordsButton: React.FC<EditKeywordsButtonProps> = ({
  tableState,
  selectedKeywordStats,
  selectedCount,
  selectionActive
}) => {
  const [openEditKeywordsDialog, setOpenEditKeywordsDialog] = useState(false);
  return (
    <>
      <EditKeywordsDialog
        open={openEditKeywordsDialog}
        setOpen={setOpenEditKeywordsDialog}
        tableState={tableState}
      />
      <DataTableToolbarButton
        tooltip="Edit selected keywords"
        iconProp={faPen}
        onClick={(event) => {
          event.stopPropagation();
          setOpenEditKeywordsDialog(true);
        }}
        disabled={!selectedCount || !selectedKeywordStats?.selectedVolumeUpdateCount}
        effect={selectionActive ? 'primary' : undefined}
        effectAnimate={false}
      />
    </>
  );
};

export default EditKeywordsButton;
